module.exports = __webpack_public_path__ + "img/stalking-paa-snapchat-4.204fc37c.png";